export default function reducer(
  state = {
    availabilityRequestStats: {},
    availabilityMatchStats: {},
    userStats: {},
    paymentChartMonthly: [],
    paymentChartDaily: [],
    availabilityRequestMatches: Array.from({ length: 100 }, () => ({ id: null })),
    availabilityRequestNotifications: Array.from({ length: 100 }, () => ({ id: null })),
    users: [],
    user: {}
  },
  action
) {
  switch (action.type) {
    case 'FETCH_ADMIN_AVAILABILITY_REQUEST_STATS_FULFILLED': {
      return { ...state, availabilityRequestStats: action.payload }
    }
    case 'FETCH_ADMIN_AVAILABILITY_MATCH_STATS_FULFILLED': {
      return { ...state, availabilityMatchStats: action.payload }
    }
    case 'FETCH_ADMIN_USER_STATS_FULFILLED': {
      return { ...state, userStats: action.payload }
    }
    case 'FETCH_ADMIN_PAYMENT_CHART_MONTHLY_FULFILLED': {
      return { ...state, paymentChartMonthly: action.payload }
    }
    case 'FETCH_ADMIN_PAYMENT_CHART_DAILY_FULFILLED': {
      return { ...state, paymentChartDaily: action.payload }
    }
    case 'FETCH_ADMIN_AVAILABILITY_REQUEST_MATCHES_FULFILLED': {
      return { ...state, availabilityRequestMatches: action.payload }
    }
    case 'FETCH_ADMIN_AVAILABILITY_REQUEST_NOTIFICATIONS_FULFILLED': {
      return { ...state, availabilityRequestNotifications: action.payload }
    }
    case 'FETCH_ADMIN_USERS_FULFILLED': {
      return { ...state, users: action.payload }
    }
    case 'FETCH_ADMIN_USER_FULFILLED': {
      return { ...state, user: action.payload }
    }
    default: {
      return state
    }
  }
}
